import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BulkAssetRoutingModule } from './bulk-asset-routing.module';
import { BulkAssetLinkComponent } from './bulk-asset-link/bulk-asset-link.component';
import { BulkAssetLandingComponent } from './bulk-asset-landing/bulk-asset-landing.component';
import { BulkAssetQrDetailsComponent } from './bulk-asset-qr-details/bulk-asset-qr-details.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';


@NgModule({
  declarations: [
    BulkAssetLinkComponent,
    BulkAssetLandingComponent,
    BulkAssetQrDetailsComponent
  ],
  imports: [
    CommonModule,
    BulkAssetRoutingModule,
    AcademicFormModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule
  ]
})
export class BulkAssetModule { }
